import { paymentsApi } from '.';

export interface BraintreeGenerateTokenRequest {
  client: string,
}

export interface BraintreeGenerateTokenData {
  token: string,
}

export interface BraintreeGenerateTokenResponse {
  data: BraintreeGenerateTokenData,
  message: string,
}

const extendedPaymentsApi = paymentsApi.injectEndpoints({
  endpoints: builder => ({
    braintreeGenerateToken: builder.mutation<BraintreeGenerateTokenResponse, BraintreeGenerateTokenRequest>({
      query: body => ({
        url: 'provider/braintree/token/generate',
        method: 'POST',
        body,
      })
    })
  })
});

export const { useBraintreeGenerateTokenMutation } = extendedPaymentsApi;
